module.exports = __webpack_public_path__ + "static/media/les26.ea33cdb0.JPG";